import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/merchant_manage',
  component: Layout,
  redirect: '/merchant_manage',
  name: 'merchant_manage',
  meta: {
    title: '商家管理',
    icon: 'shop',
  },
  children: [
    {
        path: 'merchant_index',
        name: 'merchantIndex',
        component: () => import('@/views/merchant_manage/merchant_index.vue'),
        meta: {
            title: '商家列表',
          breadcrumb: true,
            
            auth: [
                'RegimentalCommander.Merchant.menu'
            ]
        }
    },
    // {
    //     path: 'merchant_contract_index',
    //     name: 'merchantContractIndex',
    //     component: () => import('@/views/merchant_manage/merchant_contract_index.vue'),
    //     meta: {
    //         title: '商家合同列表',
    //         breadcrumb: true,
    //         // auth: [
    //         //     'Welfare.Welfare.menu'
    //         // ]
    //     }
    // },
  ],
}

export default routes
